import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainDbComponent } from './layout/main-db/main-db.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { CustomersComponent } from './components/customers/customers.component';
import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [
  { path: '', redirectTo: '/auth', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: MainDbComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'home', component: HomePageComponent },
      { path: 'clients', component: CustomersComponent }
    ]
  },
  { path: '', loadChildren: () => import('./layout/default/default.module').then(m => m.DefaultModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
